import _ from 'lodash';
import api from '../../api';
import * as types from '../mutation-types';

const state = {
  items: {},
};

const getters = {
  getYahooItemByItemCode: s => (itemCode) => {
    const Code = itemCode.toLowerCase();
    return _.get(s, ['items', Code]);
  },
};

const actions = {
  fetchYahooItem({ commit }, itemCode) {
    return api.yahoo.getItem(itemCode).then(({ data: response }) => {
      commit(types.RECEIVE_YAHOO_ITEM, response);
    });
  },
};

/* eslint no-param-reassign: 0, no-shadow: 0 */
const mutations = {
  [types.RECEIVE_YAHOO_ITEM](s, data) {
    const { Code } = data;
    s.items[Code.toLowerCase()] = data;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
